import styles from "../styles/CreateChatbot.module.css";
import React, { useContext, useState } from "react";
import ReactSlider from "react-slider";
import ReactLoading from "react-loading";
import cx from "classnames";
import { SupabaseContext } from "./Login";
import { IoCardOutline } from "react-icons/io5";
import { CiBitcoin } from "react-icons/ci";
import { TbBrandGumroad } from "react-icons/tb";
import { LiaMoneyBillWaveSolid } from "react-icons/lia";

export default function Billing({ language, chatbot }) {
  const supabase = useContext(SupabaseContext);
  const rubPerMessage = 1.8;
  const usdPerMessage = 0.018;
  const [sliderValue, setSliderValue] = useState(0);
  const [codeLoading, setCodeLoading] = useState(false);
  const [code, setCode] = useState("");

  async function checkCode() {
    console.log(code);
    setCodeLoading(true);
    const response = await fetch(
      "https://cybechat-secure-server.onrender.com/checkgumroad",

      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          code: code,
          name: chatbot.name,
        }),
      }
    );
    const resJson = await response.json();
    console.log(resJson.messagesToAdd);
    setCodeLoading(false);
  }

  return (
    <div style={{ height: "100vh" }}>
      {codeLoading ? (
        <div
          style={{
            display: "flex",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "transparent",
          }}
        >
          <ReactLoading type="spin" color="#000" height={75} width={75} />
        </div>
      ) : null}
      <h5 className={styles.header} style={{ color: "#000" }}>
        {language === "en" ? `Calculate the price: ` : `Рассчитайте цену: `}
        <br></br>
      </h5>
      <div id={styles.container}>
        <h3 id={styles.price} style={{ color: "#000" }}>
          {Number(sliderValue) * rubPerMessage === 0
            ? language === "en"
              ? "Free forever"
              : "Бесплатно навсегда"
            : `${
                language === "en"
                  ? Math.round(Number(sliderValue) * usdPerMessage * 10) / 10
                  : Math.round(Number(sliderValue) * rubPerMessage * 10) / 10
              } ${language === "en" ? "$" : "₽"}`}
        </h3>

        <div style={{ display: "flex", flexDirection: "row" }}>
          <h3
            className={styles.value}
            id={styles.changingValue}
            style={{ color: "#000" }}
          >
            {language === "en"
              ? `${sliderValue} Messages`
              : `${sliderValue} Сообщений`}

            {/* {sliderValue >= 10000 ? " + No branding!" : null} */}
          </h3>
        </div>

        <div
          style={{
            marginBottom: 40,
            marginTop: -12,
          }}
        >
          <ReactSlider
            className="mt-14"
            marks
            min={0}
            max={5000}
            step={5}
            defaultValue={0}
            onChange={(value) => setSliderValue(Math.round(value * 100) / 10)}
            renderThumb={(props, state) => (
              <div
                {...props}
                style={{ ...props.style, zIndex: 20 }}
                className="relative flex flex-col items-center w-8 h-8 -mt-2 outline-none"
              >
                <div className="absolute top-0 inline-block px-2 py-1 mb-2 -mt-8 text-xs text-white bg-gray-900 rounded-sm whitespace-nowrap">
                  {state.valueNow * 10} messages{state.valueNow > 1 && "s"}
                  {state.valueNow > 1 && "s"}
                </div>
                <div className="w-8 h-8 bg-white border-4 border-green-700 rounded-full shadow-lg cursor-pointer" />
              </div>
            )}
            renderTrack={(props, state) => (
              <div
                {...props}
                className={cx("h-4 rounded-full cursor-pointer", {
                  "bg-gray-100": state.index === 1,
                  "bg-green-700 z-10": state.index === 0,
                })}
              />
            )}
          />
        </div>
      </div>

      {chatbot !== undefined ? (
        <>
          {sliderValue !== 0 ? (
            <>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <button
                  className={styles.submitBtn}
                  style={{ marginTop: 10, marginRight: 10 }}
                  onClick={async () => {
                    setCodeLoading(true);
                    const userSession = await supabase.auth.getSession();

                    const multiplier =
                      language === "en" ? usdPerMessage : rubPerMessage;

                    const response = await fetch(
                      "https://cybechat-secure-server.onrender.com/yookassa",
                      // "http://localhost:5000/yookassa",
                      {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                          amount: (Number(sliderValue) * multiplier).toString(),
                          userEmail: userSession.data.session.user.email,
                          supabaseName: chatbot.name,
                        }),
                      }
                    );
                    const resJson = await response.json();
                    setCodeLoading(false);
                    console.log(resJson);
                    var win: any;
                    win = window.open(resJson, "_blank");

                    win.focus();
                  }}
                >
                  <IoCardOutline style={{ marginRight: 5 }} size={18} />
                  {language === "en"
                    ? "Pay with Ru card"
                    : "Оплатить российской картой"}
                </button>
                <button
                  className={styles.submitBtn}
                  style={{ marginTop: 10 }}
                  onClick={async () => {
                    // var win = window.open("https://t.me/holygoose", "_blank");
                    // win.focus();

                    const userSession = await supabase.auth.getSession();

                    const { data, e } = await supabase.from("users").select();
                    const supabaseObject = data.find(
                      (e) =>
                        e.user_email === userSession.data.session.user.email
                    );

                    const multiplier =
                      language === "en" ? usdPerMessage : rubPerMessage;

                    const response = await fetch(
                      "https://ai-chat-bot-docker.onrender.com/cryptomus",
                      // "http://localhost:5000/cryptomus",
                      {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                          amount: (Number(sliderValue) * multiplier).toString(),
                          currency: language === "en" ? "USD" : "RUB",
                          uid: supabaseObject.uid,
                        }),
                      }
                    );
                    const resJson = await response.json();
                    var win: any;
                    win = window.open(resJson.data.result.url, "_blank");

                    win.focus();
                  }}
                >
                  <CiBitcoin style={{ marginRight: 5 }} size={18} />
                  {language === "en"
                    ? "Pay with Crypto"
                    : "Оплатить криптовалютой"}
                </button>
                <button
                  className={styles.submitBtn}
                  style={{ marginTop: 10, marginLeft: 10 }}
                  onClick={async () => {
                    var win: any;
                    win = window.open(
                      "https://artemymedvedev.gumroad.com/?_gl=1*xh5k3n*_ga*MTc1Njk2MzYzNS4xNzA4MTcyOTc1*_ga_6LJN6D94N6*MTcwODM1ODMwMy42LjEuMTcwODM1ODY1OC4wLjAuMA..",
                      "_blank"
                    );
                    win.focus();
                  }}
                >
                  <TbBrandGumroad style={{ marginRight: 5 }} size={18} />
                  {language === "en"
                    ? "Buy via Gumroad"
                    : "Купить через Gumroad"}
                </button>
                <button
                  className={styles.submitBtn}
                  style={{ marginTop: 10, marginLeft: 10 }}
                  onClick={async () => {
                    var win: any;
                    win = window.open("https://t.me/holygoose", "_blank");
                    win.focus();
                  }}
                >
                  <LiaMoneyBillWaveSolid style={{ marginRight: 5 }} size={18} />
                  {language === "en"
                    ? "Alternative payment method"
                    : "Оплатить другим способом"}
                </button>
              </div>
              <h3
                className={styles.value}
                id={styles.changingValue}
                style={{ color: "#000" }}
              >
                {language === "en"
                  ? `Press "Pay with Crypto" and choose Bitcons to pay with debit card`
                  : `Нажмите "Оплатить криптовалютой" и выберете Биткоин чтобы заплатить зарубежной картой`}
              </h3>
              <h3
                className={styles.value}
                id={styles.changingValue}
                style={{ color: "#000" }}
              >
                {language === "en"
                  ? `If you want to use an alternative payment method, please contact us`
                  : `Если вы хотите оплатить другим способом, пожалуйста, свяжитесь с нами`}
              </h3>

              {/* <h3
                className={styles.value}
                id={styles.changingValue}
                style={{ color: "#000" }}
              >
                {language === "en"
                  ? `If you buy 10.000+ AI messages, you also get no branding on your chatbot`
                  : `Если вы купите более 10.000 сообщений с искусственным интеллектом, вы также не получите брендирования своего чат-бота`}
              </h3> */}
            </>
          ) : null}
          <h3 className={styles.value} style={{ color: "#000", marginTop: 50 }}>
            {" "}
            {language === "en"
              ? `Paste your code here (Gumroad): `
              : `Вставьте ваш код сюда (Gumroad): `}
          </h3>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "75%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              className={styles.billingCode}
              style={{ height: 44 }}
              onChange={(text) => setCode(text.target.value)}
              placeholder={
                language === "en"
                  ? `Paste your code here`
                  : `Вставьте ваш код сюда`
              }
            ></input>
            <button
              className={styles.submitBtn}
              style={{ marginLeft: 10, marginTop: 6 }}
              onClick={() => checkCode()}
            >
              {language === "en" ? `Submit` : `Подтвердить`}
            </button>
          </div>
        </>
      ) : (
        <h5 className={styles.header}>
          {language === "en"
            ? `Please, create a chatbot first!`
            : `Пожалуйста, сначала создайте чат-бота!`}
          <br></br>
        </h5>
      )}
    </div>
  );
}
